import React, { useEffect, useState } from "react";

import "./ServiceDetail.scss";
import { AVAILABLE_CREDIT_CARD_COD } from "constants/available-credit-card-cod-motivo";

export default function GenericDetail({
  title,
  description,
  image,
  deadline,
  checked,
  rawData,
  onToggle,
  onWarranty,
}) {
  const [paymentMethod, setPaymentMethod] = useState(""); // boleto | cartao

  useEffect(() => {
    setPaymentMethod("");
  }, [onToggle]);

  return (
    <>
      <h2 className="service-detail-title">{title}</h2>
      {description &&
        description.split("\n").map((row, idx) => (
          <p
            key={`service-generic-detail-row-${idx}`}
            style={{ textAlign: "justify" }}
          >
            {row}
          </p>
        ))}
      {image && (
        <img
          alt="service"
          src={image}
          style={{
            maxHeight: "300px",
            maxWidth: "100%",
          }}
        />
      )}
      <div style={{ textAlign: "left" }}>
        <hr />

        <h3 style={{ margin: 0, marginBottom: 10, marginTop: 10 }}>
          Condição de Pagamento
        </h3>
        {AVAILABLE_CREDIT_CARD_COD.includes(rawData["codMotivo"]) ? (
          <label>
            <input
              type="checkbox"
              className={paymentMethod === "cartao" ? "checked" : ""}
              onClick={() => setPaymentMethod("cartao")}
            />
            <span
              style={{
                fontWeight: 700,
              }}
            >
              Cartão de Crédito (Link de Pagamento)
            </span>
          </label>
        ) : null}
        <label>
          <input
            type="checkbox"
            className={paymentMethod === "boleto" ? "checked" : ""}
            onClick={() => setPaymentMethod("boleto")}
          />
          <span
            style={{
              fontWeight: 700,
            }}
          >
            Boleto com prazo de pagamento{" "}
            {rawData.condPagamento ? `de ${rawData.condPagamento}` : ``}
          </span>
        </label>

        {!paymentMethod ? null : (
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              gap: "4px",
              marginTop: "24px",
            }}
          >
            <span style={{ fontWeight: 700, fontSize: 16 }}>Prazos</span>
            {paymentMethod === "boleto" && (
              <span style={{ fontWeight: 600 }}>
                Prazo para pagamento é de{" "}
                {rawData.condPagamento ? `${rawData.condPagamento}` : ``}
              </span>
            )}
            <span style={{ fontWeight: 600 }}>
              O serviço solicitado será efetuado até 3 dias úteis
              {paymentMethod === "boleto"
                ? "."
                : " após a confirmação do pagamento, e o prazo de atendimento começará ser contado a partir da data do pagamento."}
            </span>
          </div>
        )}

        {/* {rawData && rawData.condPagamento && (
          <b>Prazo de pagamento é de {rawData.condPagamento}</b>
        )}
        <br />
        {deadline && <b>Prazo de atendimento é de {deadline}</b>} */}
      </div>
      <footer className="service-detail-footer">
        <button onClick={onWarranty} className="inline-link">
          Termos de garantia
        </button>
        <button
          className="block"
          disabled={!paymentMethod}
          onClick={() =>
            onToggle &&
            onToggle({
              paymentMethod: paymentMethod,
            })
          }
          style={{
            fontWeight: 600,
          }}
        >
          Confirmar
        </button>
      </footer>
    </>
  );
}
